module.exports = __webpack_public_path__ + "static/img/n5.89e6c2a1.jpg";